import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import PageV2 from "components/shared/PageV2";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { FETCH_FORECAST_CATEGORY_SUBMISSIONS } from "./graphql";

const CategorySubmitHistoryPage = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(
    FETCH_FORECAST_CATEGORY_SUBMISSIONS,
    {
      variables: { forecastCategoryId: id },
      fetchPolicy: "network-only",
    },
  );

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const forecastCategory = data.forecastCategory;

  const submissions = data.submissions.filter((i) => i.submittedAt);

  return (
    <PageV2
      title={`Submission History: ${forecastCategory.name}`}
      backTo="./../.."
    >
      <div className="h-full flex flex-col">
        <div className="card flex-1 overflow-auto px-0 py-2">
          {submissions.length === 0 && (
            <div className="p-6 text-center text-gray-500">
              No submissions yet.
            </div>
          )}

          {submissions.length > 0 && (
            <table className="w-full with-line">
              <tbody>
                {submissions.map((i) => (
                  <tr key={i.id}>
                    <td className="px-4">
                      <Link to={`${i.id}`}>
                        {moment(i.submittedAt).format("YYYY-MM-DD HH:mm:ss")} by{" "}
                        {i.user?.email}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </PageV2>
  );
};

export default CategorySubmitHistoryPage;
